module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-instruction-step"
  }, [_c('div', {
    staticClass: "steps"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns large-4 small-12"
  }, [_c('label', [_vm._v("Step Type"), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.step.type),
      expression: "step.type"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.step, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.$emit('resetValue')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "html"
    }
  }, [_vm._v("html")]), _c('option', {
    attrs: {
      "value": "youtube"
    }
  }, [_vm._v("youtube")]), _c('option', {
    attrs: {
      "value": "image"
    }
  }, [_vm._v("Image")]), _c('option', {
    attrs: {
      "value": "linked_image"
    }
  }, [_vm._v("Linked image")])])])]), _c('div', {
    staticClass: "columns large-8 small-12"
  }, [(_vm.step.type === 'html') ? _c('div', {
    staticClass: "editor"
  }, [_c('label', [_vm._v("Description")]), _c('Editor', {
    attrs: {
      "value": _vm.step.value
    },
    model: {
      value: (_vm.step.value),
      callback: function($$v) {
        _vm.$set(_vm.step, "value", $$v)
      },
      expression: "step.value"
    }
  })], 1) : (_vm.step.type === 'youtube') ? _c('label', [_vm._v("Youtube embed url"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.step.value),
      expression: "step.value"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.step.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.step, "value", $event.target.value)
      }
    }
  })]) : (_vm.step.type === 'image') ? _c('div', {
    staticClass: "uploader"
  }, [_c('KeplerFileUpload', {
    attrs: {
      "selected-prefix": "vehicle-instructions",
      "previewUrl": _vm.step.value,
      "selected-visibility": "public"
    },
    on: {
      "sel": function($event) {
        return _vm.handleFileSelector($event, _vm.step.type)
      }
    }
  })], 1) : (_vm.step.type === 'linked_image') ? _c('div', {
    staticClass: "uploader"
  }, [_c('label', [_vm._v("URL")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.step.image_link),
      expression: "step.image_link"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.step.image_link)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.step, "image_link", $event.target.value)
      }
    }
  }), _c('KeplerFileUpload', {
    attrs: {
      "selected-prefix": "vehicle-instructions",
      "previewUrl": _vm.step.image_url,
      "selected-visibility": "public"
    },
    on: {
      "sel": function($event) {
        return _vm.handleFileSelector($event, _vm.step.type)
      }
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "text-right",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('button', {
    staticClass: "button small warning",
    on: {
      "click": function($event) {
        return _vm.$emit('remove')
      }
    }
  }, [_vm._v("Remove")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c092df40!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/InstructionStep.vue
// module id = 2685
// module chunks = 1